import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingStatus': false,
  'loadingPendingOrders': false,
  'loading': false,
  'loadingTasks': false,
  'taskStatusList': [],
  'pendingOrdersList': [],
  'orders': [],
  'closedOrders': [],
  'tasks': [],
};

export const timeMarked = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ORDER_AND_TASK_STATUS]: (state, action) => ({
      ...state,
      'loadingStatus': true,
    }),
    [ActionTypes.FETCHED_ORDER_AND_TASK_STATUS]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'taskStatusList': action.response.data,
    }),
    [ActionTypes.FETCHED_ORDER_AND_TASK_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'taskStatusList': [],
    }),
    [ActionTypes.FETCHING_PENDING_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'loadingPendingOrders': true,
    }),
    [ActionTypes.FETCHED_PENDING_ACCESSORIES_ORDERS]: (state, action) => ({
      ...state,
      'loadingPendingOrders': false,
      'pendingOrdersList': action.response.data,
    }),
    [ActionTypes.FETCHED_PENDING_ACCESSORIES_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loadingPendingOrders': false,
      'pendingOrdersList': [],
    }),
    [ActionTypes.FETCHING_PENDING_ORDERS_LIST_BY_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN]: (state, action) => ({
      ...state,
      'loading': false,
      'orders': action.response.data.sort(
        (objA, objB) => {
          const timeA = objA.workOrderStart ? new Date(objA.workOrderStart)?.getTime() : new Date(-8640000000000000);
          const timeB = objB.workOrderStart ? new Date(objB.workOrderStart)?.getTime() : new Date(-8640000000000000);
          return timeB - timeA;
        },
      ),
    }),
    [ActionTypes.FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'orders': [],
    }),
    [ActionTypes.FETCHING_TASKS_BY_ORDER]: (state, action) => ({
      ...state,
      'loadingTasks': true,
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'tasks': action.response.data,
    }),
    [ActionTypes.FETCHED_TASKS_BY_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'tasks': [],
    }),
    [ActionTypes.FETCHING_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN]: (state, action) => ({
      ...state,
      'loadingStatus': true,
    }),
    [ActionTypes.FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'closedOrders': action.response.data,
    }),
    [ActionTypes.FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'closedOrders': [],
    }),
  })(state, action);
};
